import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { GridComponent } from './grid/grid.component';
import { GridHeaderRowComponent } from './grid-header-row/grid-header-row.component';
import { GridHeaderColumnComponent } from './grid-header-column/grid-header-column.component';
import { GridRowComponent } from './grid-row/grid-row.component';
import { GridColumnComponent } from './grid-column/grid-column.component';

import { DataGridOptions, DataGridData, DataGridColumn } from 'app/shared/components/data-grid/data-grid';
export { DataGridOptions, DataGridData, DataGridColumn };

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatCheckboxModule
  ],
  exports: [
    GridComponent,
    GridHeaderRowComponent,
    GridHeaderColumnComponent,
    GridRowComponent,
    GridColumnComponent
  ],
  declarations: [
    GridComponent,
    GridHeaderRowComponent,
    GridHeaderColumnComponent,
    GridRowComponent,
    GridColumnComponent
  ]
})
export class DataGridModule { }
